import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { SolarCalculatorResultModule } from '../solar-calculator-result.module';
import { CalculatorResultWrapper } from '../../../models/analysis/calculator-result-wrapper';
import { UserRole } from '../../../models/user/user-role.enum';
import { PowerPlant } from '../model/power-plant';
import { PaymentStatusComponent } from '../../payment-status/payment-status.component';
import { PayForFullComponent } from '../pay-for-full/pay-for-full.component';
import { PaymentStatus } from '../../../models/payment/payment-status';
import { TranslocoModule } from '@ngneat/transloco';
import { PriceType } from '../../../models/price/price';

@Component({
  selector: 'psc-result-title',
  standalone: true,
  imports: [CommonModule, SharedModule, SolarCalculatorResultModule, PaymentStatusComponent, PayForFullComponent, TranslocoModule],
  templateUrl: './result-title.component.html'
})
export class ResultTitleComponent {

  @Input() title: string;
  @Input() calculationResultWrapper: CalculatorResultWrapper;
  @Input() powerPlant: PowerPlant;

  @Input() hideSavePlant: boolean;

  @Input() hidePdfDownload: boolean;
  @Input() showPdfRolesOnly: UserRole[];
  @Input() advancedPdfDownload: boolean = true;
  protected readonly PaymentStatus = PaymentStatus;
  protected readonly UserRole = UserRole;
  protected readonly PriceType = PriceType;
}
